import React, { useState, useContext, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Page from '../../components/page';
import Department from '../../components/single-department';
import DepartmentSkeleton from '../../components/department-skeleton';
import { api } from '../../providers/apiClient';
import Breadcrumbs from '../../components/layout/breadcrumbs';
import { ContextUser } from '../../providers/ContextUser';
import { ContextSearch } from '../../providers/ContextSearch';
import InfoData from '../../components/info-data';
import Search from '../../components/search';
import NoResults from '../../components/no-result';
import { applyTextFilters, hasActiveFilters } from '../../utils';

const PageUnit = ({ isCollapsed }) => {
  const { handleUpdateCurrentOrganization } = useContext(ContextUser);
  const { searchValues, setSearchValues } = useContext(ContextSearch);
  const { unitId } = useParams();
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [unit, setUnit] = useState();
  const [searchDepResult, setSearchDepResult] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  // Carrega dados apenas uma vez na montagem do componente
  useEffect(() => {
    const loadData = async () => {
      try {
        setIsFetching(true);
        
        const response = await api.get(`/units/${unitId}/departments`);
        const data = response.data;
        
        // Atualiza estados
        setDepartments(data.departments);
        setUnit(data);
        setBreadcrumbs(data.breadcrumbs);
        handleUpdateCurrentOrganization(data.organization);
        
        // Aplica filtros salvos após carregar dados
        applyFiltersLocally(data.departments, searchValues['unit'] || {});
        
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      } finally {
        setIsFetching(false);
      }
    };

    loadData();
  }, []); // Sem dependências - executa apenas uma vez

  // Aplica filtros localmente quando searchValues mudar
  useEffect(() => {
    if (departments.length > 0) {
      if (hasActiveFilters(searchValues, 'unit')) {
        applyFiltersLocally(departments, searchValues['unit']);
      } else {
        // Se não há filtros ativos, mostra todos os departamentos
        setSearchDepResult(departments);
      }
    }
  }, [searchValues, departments]);



  // Função para aplicar filtros localmente sem chamar API
  const applyFiltersLocally = (allDepartments, filters) => {
    const searchFields = ['name', 'responsible.name', 'responsible.email'];
    applyTextFilters(allDepartments, filters, searchFields, setSearchDepResult);
  };

  return (
    <>
      <Breadcrumbs id='breadcrumbs-unit' path={breadcrumbs} />
      <Page id='page-unit' title={unit && unit.name}>
        <InfoData id='unit-info-data' compliance={unit?.compliance} riskMatrix={unit?.riskMatrix} />
        <Search
          id='search-unit'
          data={departments}
          fields={['name', 'responsible.name', 'responsible.email']}
          placeholder='Busque por departamento ou dados do responsável...'
          setSearchResult={setSearchDepResult}
          onSearchTextChange={setSearchValues}
          pageName='unit'
        />
        <div style={{ display: 'block' }}>
          <Row id='unit-departments-grid' style={{ width: '100%' }} className='g-3'>
            {isFetching ? (
              [0, 1, 2, 3, 4, 5].map((item) => (
                <Col id={`skeleton-department-${item}`} md={isCollapsed ? 4 : 6} key={`skeleton-${item}`}>
                  <DepartmentSkeleton id={`skeleton-department-${item}`} />
                </Col>
              ))
            ) : searchDepResult.length > 0 ? (
              searchDepResult.map((item) => (
                <Col id={`department-card-${item.id}`} md={isCollapsed ? 4 : 6} key={item.id}>
                  <Department item={item} />
                </Col>
              ))
            ) : (
              <NoResults
                id='no-results-unit'
                message='Nenhum departamento encrontrado'
                searchText={searchValues['unit']?.text || ''}
              />
            )}
          </Row>
        </div>
      </Page>
    </>
  );
};

export default PageUnit;
